import React from 'react';
import { Grid } from '@material-ui/core';
import { Text, Colors } from 'library';

const JobCardChip = ({
    color,
    textColor,
    text,
    style,
}: {
    color: Colors;
    textColor: Colors;
    text: string;
    style?: React.CSSProperties;
}) => {
    return (
        <Grid style={{ ...styles.chip, backgroundColor: color, ...style }}>
            <Text variant="body1" bold color={textColor} textStyle={styles.text}>
                {text}
            </Text>
        </Grid>
    );
};

export default JobCardChip;

const styles = {
    chip: {
        borderRadius: 20,
    },
    text: {
        fontSize: 12,
        padding: 8,
    },
};
